import { useContext } from "react";
import { Container } from "../components/common-components";
import { FormContextMA } from "../form-context";
import { getTreatmentDrugs } from "../../patient/clinical-services/service-steps/treatment/data";
import { BillForService } from "../components/BillForService";
import { PrescriptionDetails } from "../components/PrescriptionDetails";

export const CommunicationForBillingForm = ({}) => {
  const { treatment, alertData } = useContext(FormContextMA);
  const allDrugs = getTreatmentDrugs(treatment) || [];

  return (
    <div className="space-y-20">
      {!alertData.EndServiceAndRefer && allDrugs.length > 0 &&
        allDrugs?.map((d) => (
          <Container key={d.id}>
            <PrescriptionDetails drug={d} />
          </Container>
        ))}
      {alertData.EndServiceAndRefer && (
        <Container>
          <BillForService />
        </Container>
      )}
    </div>
  );
};
